import { createContext } from 'react';
import type { ComponentType } from 'react';

import displayName from '../../display-name';

import type { Optional } from '@skyscanner-internal/landing-pages-shared-types/types-shared/components';
import type { Configuration } from '@skyscanner-internal/landing-pages-shared-types/types-shared/hotels-components/types';

const DEFAULT_CONFIGS = {};

interface ContextProps {
  configs: Configuration;
}

const ConfigurationContext = createContext<Configuration>(DEFAULT_CONFIGS);

// eslint-disable-next-line import/prefer-default-export
export const withConfiguration = <P extends ContextProps>(
  Component: ComponentType<P>,
): ComponentType<Optional<P, 'configs'>> => {
  const Product = (props: Optional<P, 'configs'>) => (
    <ConfigurationContext.Consumer>
      {(configs) => (
        // @ts-expect-error -- legacy code we expect that configs can be overwritten in the unit tests
        <Component configs={configs} {...(props as P)} />
      )}
    </ConfigurationContext.Consumer>
  );

  Product.displayName = displayName(Component);

  return Product;
};
